var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PRICE_VAT_TIP',{attrs:{"showVATTip":_vm.showVATTip,"currentCountry":_vm.currentCountry}})}
var staticRenderFns = []

export { render, staticRenderFns }